import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="bg-[#2c2c2c] w-full px-8 py-6 box-border">
        {/* Main Row */}
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-6 pb-5 border-b border-white/[0.08]">
          {/* Left - Logo */}
          <div className="flex items-center">
            <img
              src="https://asianheartinstitute.org/wp-content/uploads/2023/12/footer-logo-white.webp"
              alt="Asian Heart Institute"
              className="h-12 opacity-90"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "block";
              }}
            />
            <span
              className="text-white text-base font-medium tracking-widest"
              style={{ display: "none" }}
            >
              Asian Heart Institute
            </span>
          </div>

          {/* Right - Accreditation Cards */}
          <div className="flex flex-col sm:flex-row gap-3">
            {/* JCI Card */}
            <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3 w-full sm:w-[210px]">
              <img
                src="https://asianheartinstitute.org/wp-content/themes/ahi-theme/img/logo/footer-jci.webp"
                alt="JCI"
                className="w-10 h-10 object-contain rounded-full bg-white/10 p-1 shrink-0"
              />
              <div>
                <p className="text-[10px] uppercase tracking-widest text-[#c8a96e] font-medium mb-0.5 m-0">
                  JCI Gold · 7×
                </p>
                <p className="text-[13px] font-medium text-white mb-0.5 m-0">
                  JCI Gold Accredited
                </p>
                <p className="text-[11px] text-white/40 leading-relaxed font-light m-0">
                  International standards in clinical care & training.
                </p>
              </div>
            </div>

            {/* NABH Card */}
            <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3 w-full sm:w-[210px]">
              <img
                src="https://asianheartinstitute.org/wp-content/themes/ahi-theme/img/logo/footer-nabh.webp"
                alt="NABH"
                className="w-10 h-10 object-contain rounded-full bg-white/10 p-1 shrink-0"
              />
              <div>
                <p className="text-[10px] uppercase tracking-widest text-[#c8a96e] font-medium mb-0.5 m-0">
                  NABH Certified
                </p>
                <p className="text-[13px] font-medium text-white mb-0.5 m-0">
                  NABH Accredited
                </p>
                <p className="text-[11px] text-white/40 leading-relaxed font-light m-0">
                  Highest patient safety, quality & rights assured.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom - Copyright */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-4">
          <p className="text-[11px] text-white/20 m-0 text-center">
            © 2026 Asian Heart Institute. All rights reserved.
          </p>
        </div>
      </footer>

      {/* <footer className="main-footer">
        <div className="footer-content">
          <div className="footer-top">
            <div className="footer-logo-section">
              <img
                src="https://asianheartinstitute.org/wp-content/uploads/2023/12/footer-logo-white.webp"
                alt="Asian Heart Institute Logo"
                className="footer-logo"
              />
              <div className="footer-middle">
                <div className="social-links">
                  <a
                    href="https://www.facebook.com/Asian.Heart.Hospital/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <i className="fab fa-facebook-f social-icon"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/asianheartinstitute/?hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <i className="fab fa-instagram social-icon"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/asian-heart-institute-and-research-center/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <i className="fab fa-linkedin-in social-icon"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/user/asianheartinstitute"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                  >
                    <i className="fab fa-youtube social-icon"></i>
                  </a>
                  <a
                    href="https://api.whatsapp.com/send/?phone=919820027691"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp"
                  >
                    <i className="fab fa-whatsapp social-icon"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="footer-contact">
              <h4>Contact Us</h4>
              <div className="contact-item">
                <span className="icon">
                  <span className="icon">
                    <i
                      className="fas fa-map-marker-alt"
                      style={{ color: "#0095DA" }}
                    ></i>
                  </span>
                </span>
                <span>
                  Asian Heart Institute G / N Block, Bandra Kurla Complex,
                  Bandra (E), Mumbai 400 051, Maharashtra, INDIA.
                </span>
              </div>
              <div className="contact-item">
                <span className="icon">
                  <i
                    className="fas fa-phone-alt"
                    style={{ color: "#0095DA" }}
                  ></i>
                </span>
                <span>+91 22 6698 6666</span>
              </div>
              <div className="contact-item">
                <span className="icon">
                  <i
                    className="fas fa-envelope"
                    style={{ color: "#0095DA" }}
                  ></i>
                </span>
                <span>info@ahirc.com</span>
              </div>
            </div>
          </div>

          <div className="accreditations-grid">
            <div className="accreditation-card">
              <div className="badge-container">
                <img
                  src="https://asianheartinstitute.org/wp-content/themes/ahi-theme/img/logo/footer-jci.webp"
                  alt="JCI Gold Accreditation"
                  className="accreditation-badge"
                  loading="lazy"
                />
              </div>
              <div className="accreditation-details">
                <h4 className="accreditation-title">JCI Gold Accredited</h4>
                <p className="accreditation-description">
                  First Hospital Accredited JCI Gold 6 times for meeting
                  international standards in clinical care, training &
                  processes.
                </p>
              </div>
            </div>

            <div className="accreditation-card">
              <div className="badge-container">
                <img
                  src="https://asianheartinstitute.org/wp-content/themes/ahi-theme/img/logo/footer-nabh.webp"
                  alt="NABH Accreditation"
                  className="accreditation-badge"
                  loading="lazy"
                />
              </div>
              <div className="accreditation-details">
                <h4 className="accreditation-title">NABH Accredited</h4>
                <p className="accreditation-description">
                  Certified for continuous best-quality service to patients and
                  ensuring their highest safety and rights.
                </p>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p style={{ color: "#fff" }}>
              © {new Date().getFullYear()} Asian Heart Institute
            </p>
          </div>
        </div>
      </footer> */}
    </>
  );
};

export default Footer;
